import { isCapacitorNative } from './isCapacitorNative';

const SAFE_AREA_VAR = '--offizz-safe-area-top';
const NATIVE_CLASS = 'native-shell';
/** Used when Android WebView reports 0 for the status-bar inset (punch-hole phones). */
const ANDROID_STATUS_FALLBACK_PX = 47;

function readCssEnvSafeAreaTop(): number {
  if (typeof document === 'undefined') {
    return 0;
  }
  const probe = document.createElement('div');
  probe.style.paddingTop = 'env(safe-area-inset-top, 0px)';
  probe.style.position = 'absolute';
  probe.style.visibility = 'hidden';
  document.documentElement.appendChild(probe);
  const px = parseFloat(getComputedStyle(probe).paddingTop) || 0;
  probe.remove();
  return px;
}

function setSafeAreaTopPx(px: number): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.style.setProperty(SAFE_AREA_VAR, `${Math.max(0, Math.round(px))}px`);
}

/**
 * Push the SPA below the Android/iOS status bar in the Capacitor shell.
 * Browser tabs already sit under the system chrome, so they are left unchanged.
 */
export async function applyNativeSafeArea(): Promise<void> {
  if (typeof document === 'undefined' || !isCapacitorNative()) {
    return;
  }
  document.documentElement.classList.add(NATIVE_CLASS);
  const envInset = readCssEnvSafeAreaTop();
  setSafeAreaTopPx(envInset > 8 ? envInset : ANDROID_STATUS_FALLBACK_PX);

  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setOverlaysWebView({ overlay: true });
    await StatusBar.setStyle({ style: Style.Light });
    const info = await StatusBar.getInfo();
    if (typeof info.height === 'number' && Number.isFinite(info.height) && info.height > 8) {
      setSafeAreaTopPx(info.height);
    }
  } catch {
    /* plugin missing in tests / web */
  }
}
